import { getTemplateNavHeaderStyles } from './NavHeader.styles'

const t = document.createElement('template')
t.innerHTML = `
<div class="dropdown-item" role="menuitem">
 <slot></slot>
</div>
`

class NavHeaderUtilityMenuItem extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    document.AscendAwesome?.LogManager?.logDebug('NavHeaderUtilityMenuItem connectedCallback')

    this.shadowRoot?.querySelector('.dropdown-item')?.addEventListener('click', () => {
      this.dispatchEvent(
        new CustomEvent('navheader-utilitymenu-item-selected', {
          detail: { item: this },
          bubbles: true,
          composed: true,
        }),
      )

      const parentMenu = this.closest('ts-navheader-utility-menu')
      parentMenu?.setAttribute('is-open', 'false')
    })
  }
}

if (!customElements.get('ts-navheader-utility-menu-item')) {
  customElements.define('ts-navheader-utility-menu-item', NavHeaderUtilityMenuItem)
}
export { NavHeaderUtilityMenuItem }
